module.exports = __webpack_public_path__ + "img/title-bg.22fc6376.png";